import React, { JSX } from 'react';
import { Autocomplete, InputAdornment, TextField, Typography } from '@mui/material';

// Utils
import { StockDetailsContent } from '../../../constants/Constants';
import { ALL, EMPTY_CARRIER_OPTION, SearchableOption, searchableFilterSx } from './stockDetails.constants';

// Common Components
import FormInputCollection from '../../common/FormInputCollection/FormInputCollection';

// Assets
import carrierIcon from '../../../assets/images/carrier-icon.svg';

interface StockCarrierFilterProps {
  carrierId: string;
  carrierOptions: SearchableOption[];
  isExternalUser: boolean;
  noCarrierAssigned: boolean;
  onChange: (carrierId: string) => void;
}

export default function StockCarrierFilter({
  carrierId,
  carrierOptions,
  isExternalUser,
  noCarrierAssigned,
  onChange,
}: StockCarrierFilterProps): JSX.Element {
  return (
    <FormInputCollection
      label={StockDetailsContent.carrierLabel}
      style={{
        marginRight: '1.5em',
        width: '150px',
        flexShrink: 0,
      }}
    >
      {noCarrierAssigned ? (
        <Typography
          variant='body2'
          sx={{
            color: 'error.main',
          }}
        >
          No carrier assigned in scope. Contact admin.
        </Typography>
      ) : (
        <Autocomplete
          id='carrier'
          options={carrierOptions}
          value={
            carrierOptions.find((option) => option.value === carrierId) ??
            carrierOptions.find((option) => option.value !== ALL) ??
            EMPTY_CARRIER_OPTION
          }
          isOptionEqualToValue={(option, value) => option.value === value.value}
          getOptionLabel={(option) => option.label}
          onChange={(_, option) => onChange(option?.value ?? ALL)}
          size='small'
          disableClearable
          sx={{
            ...searchableFilterSx,
            width: '150px',
          }}
          ListboxProps={{
            sx: {
              maxHeight: 320,
              '& .MuiAutocomplete-option': {
                minHeight: 40,
                fontSize: 12,
              },
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={isExternalUser ? StockDetailsContent.carrierLabel : StockDetailsContent.allOptionLabel}
              sx={{
                '& .MuiOutlinedInput-root': {
                  paddingLeft: '8px !important',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#E2E8F0',
                },
              }}
              InputProps={{
                ...params.InputProps,

                startAdornment: (
                  <InputAdornment position='start'>
                    <img src={carrierIcon} alt='' aria-hidden='true' />
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
      )}
    </FormInputCollection>
  );
}
